import type { ReactElement } from 'react';
import { Redirect, Route } from 'react-router-dom';

import { RouteGuard } from '@makemydeal/dr-sales-checkin-components';
import { ManageDocuments } from '@makemydeal/dr-activities-ddj';
import { FEATURES, routingConfig } from '@makemydeal/dr-sales-checkin-types';

import ShowroomSectionStack from '../ShowroomSectionStack/ShowroomSectionStack';
import BrowseInventory from './content/BrowseInventory';
import DealSummary from './content/DealSummary';
import Financing from './content/Financing';
import TradeIn from './content/TradeIn';
import VehicleDetails from './content/VehicleDetails';

/**
 * TODO: HL:
 * - We need to remove the routes that is not needed when we have full Page scroll available. - PENDING
 * - Once full page scroll is available then we should remove the route that is not needed - CLEANUP - US required.
 * - This function should only return routes that is based on isFullScrollEnabled condition. Lets move inventory, managedocuments + Redirect to Showroom.tsx file
 */
export const buildShowroomRoutes = (isFullScrollEnabled: boolean, search: string): ReactElement[] => [
    // The page address and the takeovers exist only under the toggle. With it off none of them is
    // registered, so those addresses fall through to the catch-all like any other unknown route.
    //
    // Takeovers are declared ahead of the Build Your Offer guards, whose non-exact paths also
    // match these sub-routes. Hardcoded rather than mapped from a `takeoverRoutes` array: swapping
    // a takeover's `component` is the separate takeover-content US's one-line edit here.
    ...(isFullScrollEnabled
        ? [
              <Route key="build-your-offer" path={routingConfig.BUILD_YOUR_OFFER} component={ShowroomSectionStack} />,
              <RouteGuard
                  key={routingConfig.TRADE_IN_TAKEOVER}
                  feature={FEATURES.TRADE_IN}
                  path={routingConfig.TRADE_IN_TAKEOVER}
                  component={TradeIn}
              />,
              <RouteGuard
                  key={routingConfig.CUSTOMER_DETAILS_TAKEOVER}
                  feature={FEATURES.CUSTOMER_DETAILS}
                  path={routingConfig.CUSTOMER_DETAILS_TAKEOVER}
                  component={Financing}
              />
          ]
        : []),
    <RouteGuard
        key={routingConfig.VEHICLE_DETAILS}
        feature={FEATURES.VEHICLE_DETAILS}
        path={routingConfig.VEHICLE_DETAILS}
        component={VehicleDetails}
    />,
    <RouteGuard key={routingConfig.TRADE_IN} feature={FEATURES.TRADE_IN} path={routingConfig.TRADE_IN} component={TradeIn} />,
    <RouteGuard
        key={routingConfig.FINANCING}
        feature={FEATURES.CUSTOMER_DETAILS}
        path={routingConfig.FINANCING}
        component={Financing}
    />,
    <RouteGuard
        key={routingConfig.DEAL_SUMMARY}
        feature={FEATURES.DEAL_SUMMARY}
        path={routingConfig.DEAL_SUMMARY}
        component={DealSummary}
    />,
    <RouteGuard
        key={routingConfig.INVENTORY}
        feature={FEATURES.BROWSE_INVENTORY}
        path={routingConfig.INVENTORY}
        component={BrowseInventory}
    />,
    <RouteGuard
        key={routingConfig.MANAGE_DOCUMENTS}
        feature={FEATURES.MANAGE_DOCUMENTS}
        path={routingConfig.MANAGE_DOCUMENTS}
        component={ManageDocuments}
    />,
    <Redirect key="catch-all" to={`${routingConfig.INVENTORY}${search}`} />
];
